import { CustomValidator } from "@rjsf/utils";
import { useMemo } from "react";

import { GMNClosureTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GmnFormProps } from "@/types/form-types";

import { useGmnUiSchema } from "../../schema/gmn-ui-schema";

import { getGmnClosureSchema } from "./schema/gmn-closure-schema";

export function GmnClosureForm(props: GmnFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { formData, handleChange } = useBrostarFormDataStorage<GMNClosureTask>({
    key: "gmnClosure",
    task: task as GMNClosureTask | undefined,
  });

  const uiSchema = useGmnUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(() => getGmnClosureSchema(type), [type]);

  const customValidate: CustomValidator<GMNClosureTask> = (
    formData: GMNClosureTask | undefined,
    errors
  ) => {
    const date = formData?.sourcedocumentData?.endDateMonitoring;
    if (date && new Date(date) > new Date()) {
      errors["sourcedocumentData"]?.["endDateMonitoring"]?.addError(
        "Datum mag niet in de toekomst zijn"
      );
    }
    return errors;
  };

  const onSubmit = async () => {
    if (!formData) return;
    await api.createGmnClosure(formData);
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      customValidate={customValidate}
      uploadTask={oldUploadTask}
    />
  );
}
